import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { useSearchSetState } from '../../context/search';
import Icon from '../icon';
import { getThemeColor } from '../../utils/styles';
import mq from '../../utils/mq';

interface SearchButtonProps {
  show?: boolean;
  onOpen?: () => void;
}

export const SearchButton: FC<SearchButtonProps> = (props) => {
  const { show, onOpen } = props;
  const setSearchState = useSearchSetState();

  if (!show) return null;

  return (
    <>
      <Button
        type="button"
        onClick={() => {
          setSearchState(true);
          if (onOpen) onOpen();
        }}
      >
        <Icon name="magnify" />
      </Button>
    </>
  );
};

const Button = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover path {
    fill: ${getThemeColor('primary')};
  }

  svg {
    path {
      fill: ${getThemeColor('black')};

      ${mq.tablet(css`
        fill: ${getThemeColor('white')};
      `)};
    }
  }
`;
